export class UploadImageApiService {
  constructor(http) {
    this.endpoint = '/upload/image/';
    this.http = http;
  }
  async upload(file) {
    const headers = { 'Content-Type': 'multipart/form-data' };
    const { data } = await this.http.instance.post(this.endpoint, file, {
      headers
    });
    const url =
    //  process.env.NODE_ENV === 'production'
    //    ? data.image_url
    //    : data.image_url
    //    ? process.env.VUE_APP_API_URL + data.image_url
    //    : 
    data.image_url;
    return url;
  }
}
